import { render, staticRenderFns } from "./TorListe.vue?vue&type=template&id=37b573a3"
import script from "./TorListe.vue?vue&type=script&lang=js"
export * from "./TorListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports